import { USERS } from "../actions-constants/users.constants"
import { TopbarButton } from "../store"
import { UserIdha } from "@idha/idha-types"

export function setUserList(userList: UserIdha[]) {
    return {
        type: USERS.SET_USER_LIST,
        userList: userList
    }
}

export function showUserExchangeDialog() {
    return {
        type: USERS.SET_USER_EXCHANGE_DIALOG_VISIBILITY,
        exchangeUserVisible: true
    }
}


export function hideUserExchangeDialog() {
    return {
        type: USERS.SET_USER_EXCHANGE_DIALOG_VISIBILITY,
        exchangeUserVisible: false
    }
}
